import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ContactPage from '../ContactPage/ContactPage';
import MainPage from '../HomePage2/MainPage';
import WhoWeAre from '../AboutUsPage/WhoWeAre';
import OurJourney from '../AboutUsPage/OurJourney';
import LeadershipTeam from '../AboutUsPage/LeadershipTeam';
import TeamMember from '../AboutUsPage/TeamMember';
import LifeSeverArmy from '../Our-Initiatives/LifeSeverArmy';
import SuccessStories from '../ImpactStories.js/SuccessStories';
import Testimonials from '../ImpactStories.js/Testimonials';
import TreePlantation from '../Gallery/TreePlantation';
import GalleryDemo from '../Gallery/GalleryDemo';
import GalleryCoverflow from '../Gallery/GalleryCoverflow';
import GalleryWall from '../Gallery/GalleryWall';
import GalleryAccordion from '../Gallery/GalleryAccordion';
import GalleryTilt from '../Gallery/GalleryTilt';
import GalleryRing from '../Gallery/GalleryRing';
import GalleryFlip from '../Gallery/GalleryFlip';
import GalleryStack from '../Gallery/GalleryStack';
import BloodDonation from '../Gallery/BloodDonation';
import BloodDonationCamps from '../Gallery/BloodDonationCamps';
import AwarenessCampaigns from '../Gallery/AwarenessCampaigns';
import OrphangeVisit from '../Gallery/OrphangeVisit';
import HandicapCenterVisit from '../Gallery/HandicapCenterVisit';
import SchoolActivity from '../Gallery/SchoolActivity';
import FoodDonationDrive from '../Gallery/FoodDonationDrive';
import StickerCampaign from '../Gallery/StickerCampaign';
import PublicAwarenessProgram from '../Gallery/PublicAwarenessProgram';
import VolunteerApportunities from '../Join-us/VolunteerApportunities';
import Donate from '../Join-us/Donate';
import Achievements from '../ImpactStories.js/Achievements';
import Faq from '../FAQ/Faq';
import PrivacyPolicy from '../PrivacyPolicy';
import TermsConditions from '../TermsConditions';
import SocialMediaLinks from '../SocialMediaLinks';
import LegalDocuments from '../LegalDocuments';
import CorporateeDonations from '../CooperateeDonation/CooperateeDonation';
import PDFs from '../PDFs/PDFs';
import CookiePolicy from '../CookiePolicy';
import PopupResources from '../../main-component/popupModal/PopupResources';
import Newsletters from '../Newsletters/Newsletters';
import NotFoundPage from '../404/NotFoundPage';
import HumanityBlogPage from "../Blogs/HumanityBlogPage";
import WhenDiyasMeetHeart from "./../Blogs/WhenDiyasMeetHearts";
import HeartsofService from "../Blogs/HeartsofService";
import ThePulseofChange from "../Blogs/ThePulseofChange";
import WhenGratitudeFinds from "../Blogs/WhenGratitudeFinds";
import SeedsofChange from "../Blogs/SeedsofChange";
import Blogs from "../Blogs/Blogs";
import BlogPost from "../Blogs/BlogPost";
import ShareWidget from "../../components/ShareWidget/ShareWidget";

const AllRoute = () => {

  return (
    <div className="App" style={{ overflowX: 'hidden' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage path="homepage" />} />
          
          <Route path="about-us/who-we-are" element={<WhoWeAre path="about-us/who-we-are" />} />
          <Route path="about-us/our-journey" element={<OurJourney path="about-us/our-journey" />} />
          <Route path="about-us/leadership-team" element={<LeadershipTeam path="about-us/leadership-team" />} />
          <Route path="about-us/leadership-team/:slug" element={<TeamMember />} />

          <Route path="impact/success-stories" element={<SuccessStories path="impact/success-stories" />} />
          <Route path="impact/testimonials" element={<Testimonials path="impact/testimonials" />} />
          <Route path="impact/achievements" element={<Achievements path="impact/achievements" />} />

        
          <Route path="initiatives/life-saver-army" element={<LifeSeverArmy path="initiatives/life-saver-army" />} />
          

          <Route path="gallery/demo" element={<GalleryDemo />} />
          <Route path="gallery/demo-2" element={<GalleryCoverflow />} />
          <Route path="gallery/demo-3" element={<GalleryWall />} />
          <Route path="gallery/demo-4" element={<GalleryAccordion />} />
          <Route path="gallery/demo-5" element={<GalleryTilt />} />
          <Route path="gallery/demo-6" element={<GalleryRing />} />
          <Route path="gallery/demo-7" element={<GalleryFlip />} />
          <Route path="gallery/demo-8" element={<GalleryStack />} />
          {/* Blood Donation Drives gallery was removed; old links land on the camps gallery. */}
          <Route path="gallery/blood-donation-drives" element={<Navigate to="/gallery/blood-donation-camps" replace />} />
          <Route path="gallery/blood-donation-camps" element={<BloodDonationCamps />} />
          <Route path="gallery/awareness-campaigns" element={<AwarenessCampaigns />} />
          <Route path="gallery/tree-plantation" element={<TreePlantation path="gallery/tree-plantation" />} />
          <Route path="gallery/blood-donation" element={<BloodDonation path="gallery/blood-donation" />} />
          <Route path="gallery/orphanage-visit" element={<OrphangeVisit path="gallery/orphanage-visit" />} />
          <Route path="gallery/handicap-center-visit" element={<HandicapCenterVisit path="gallery/handicap-center-visit" />} />
          <Route path="gallery/food-donation-drive" element={<FoodDonationDrive path="gallery/food-donation-drive" />} />
          <Route path="gallery/school-activity" element={<SchoolActivity path="gallery/school-activity" />} />
          <Route path="gallery/sticker-campaign" element={<StickerCampaign path="gallery/sticker-campaign" />} />
          <Route path="gallery/public-awareness-program" element={<PublicAwarenessProgram path="gallery/public-awareness-program" />} />

          <Route path="join-us/volunteer-opportunities" element={<VolunteerApportunities path="join-us/volunteer-opportunities" />} />
          <Route path="join-us/donate" element={<Donate path="join-us/donate" />} />

          <Route path="faqs" element={<Faq path="faqs" />} />
          <Route path="contact-us" element={<ContactPage path="contact-us" />} />
          <Route path="our-bulletin/newsletters" element={<Newsletters />} />

          <Route path="resources" element={<PopupResources />} />
          <Route path="legal-documents" element={<LegalDocuments />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />

          <Route path="social-media-links" element={<SocialMediaLinks />} />
          <Route path="pdfs" element={<PDFs />} />
          <Route path="corporate-donations" element={<CorporateeDonations />} />

            {/* The original blogs stay as hand-built pages */}
            <Route path="our-bulletin/where-humanity-finds-its-purpose" element={<HumanityBlogPage />} />
            <Route path="our-bulletin/the-pulse-of-change-beats" element={<ThePulseofChange />} />
            <Route path="our-bulletin/when-diyas-meet-hearts" element={<WhenDiyasMeetHeart />} />
            <Route path="our-bulletin/when-gratitude-finds" element={<WhenGratitudeFinds />} />
            <Route path="our-bulletin/hearts-of-service" element={<HeartsofService />} />
            <Route path="our-bulletin/seeds-of-change" element={<SeedsofChange />} />

            <Route path="our-bulletin/blogs" element={<Blogs />} />

            {/* Anything else under our-bulletin is a blog published from the CMS.
                The static paths above still take priority in React Router v6. */}
            <Route path="our-bulletin/:slug" element={<BlogPost />} />

          <Route path="*" element={<NotFoundPage />} />

        </Routes>

        {/* Global floating social Share speed-dial — a single copy for the
            whole site (renders on every route). Replaces the old per-page
            WhatsApp button and the per-page ShareWidget copies. */}
        <ShareWidget />
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
